import { Injectable } from '@angular/core';
import { CommonConstants } from '../utilities/commonConstants';

@Injectable({
    providedIn: 'root'
})
export class GoogleAnalyticsService {

    constructor() {
    }

    public pushToDataLayer(obj) {
        let url: any = window.location.pathname;
        url = url.split('/');
        const bflJourney = url.includes(CommonConstants.QueryParamsKeys.marketplace);
        if (bflJourney) {
            const dataLayer: any = window['dataLayer'];
            dataLayer.push(obj);
        }
    }
}
